export default __webpack_public_path__ + "static/media/crackers-wide@3x.493233f6.jpg";